import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TipProblema, TipProblemaUpdate } from './tip-problema.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TipProblemaService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getTipuriProblemaUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblema.getTipuriProblema;
    private getTipuriProblemaActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblema.getTipuriProblemaActive;
    private getTipuriProblemaPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblema.getTipuriProblemaPublic;
    private storeTipProblemaUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblema.storeTipProblema;
    private updateTipProblemaUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblema.updateTipProblema;
    private deleteTipProblemaUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblema.deleteTipProblema;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblema.changeStatusTipProblemaActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblema.changeStatusTipProblemaPublic;

    constructor(private http: HttpClient) { }

    addTipProblema(tipProblema: TipProblema) {
        return this.http.post(this.storeTipProblemaUrl, tipProblema, this.httpOptions);
    }

    updateTipProblema(tipProblema: TipProblemaUpdate) {
        return this.http.put(this.updateTipProblemaUrl, tipProblema, this.httpOptions);
    }

    deleteTipProblema(id: number) {
        return this.http.delete(this.deleteTipProblemaUrl + id);
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    getTipuriProblema() {
        return this.http.get(this.getTipuriProblemaUrl, this.httpOptions);
    }

    getTipuriProblemaActive() {
        return this.http.get(this.getTipuriProblemaActiveUrl, this.httpOptions);
    }

    getTipuriProblemaPublic() {
        return this.http.get(this.getTipuriProblemaPublicUrl, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
